import React from "react";
import GlobalStyles from "../../base/ui/components/GlobalStyles.web";
import JitsiThemeProvider from "../../base/ui/components/JitsiThemeProvider.web";
import DialogContainer from "../../base/ui/components/web/DialogContainer";
import ChromeExtensionBanner from "../../chrome-extension-banner/components/ChromeExtensionBanner.web";
import OverlayContainer from "../../overlay/components/web/OverlayContainer";
import { AbstractApp } from "./AbstractApp";
// Register middlewares and reducers.
import "../middlewares";
import "../reducers";
/**
 * Root app {@code Component} on Web/React.
 *
 * @augments AbstractApp
 */
export class App extends AbstractApp {
    /**
     * Creates an extra {@link ReactElement}s to be added (unconditionally)
     * alongside the main element.
     *
     * @abstract
     * @protected
     * @returns {ReactElement}
     */
    _createExtraElement() {
        return (React.createElement(JitsiThemeProvider, null,
            React.createElement(OverlayContainer, null)));
    }
    /**
     * Overrides the parent method to inject {@link AtlasKitThemeProvider} as
     * the top most component.
     *
     * @override
     */
    _createMainElement(component, props) {
        return (React.createElement(JitsiThemeProvider, null,
            React.createElement(GlobalStyles, null),
            React.createElement(ChromeExtensionBanner, null),
            component ? super._createMainElement(component, props) : null));
    }
    /**
     * Renders the platform specific dialog container.
     *
     * @returns {React$Element}
     */
    _renderDialogContainer() {
        return (React.createElement(JitsiThemeProvider, null,
            React.createElement(DialogContainer, null)));
    }
}
